import { gql } from 'apollo-angular';
import { Label } from '../../entities/label/label';

export interface LabelFilter {
  name?: string;
  scope?: string;
  text?: string;
}

export const GET_LABELS_QUERY = gql`
query getLabels($filter: LabelFilter){
  getLabels(filter: $filter){
    id
    externalId
    name
    scope
    scopedName
    color
    description
  }
}
`;

export interface GetLabelsResponse {
  getLabels: Label[];
  loading: boolean;
}
